export const INVITE_CONFIRMATION = "INVITE_CONFIRMATION";
export const INVITE_CONFIRMATION_SUCCESS = "INVITE_CONFIRMATION_SUCCESS";
export const INVITE_CONFIRMATION_FAIL = "INVITE_CONFIRMATION_FAIL";

export const GET_ORG_SSO_STATUS = "GET_ORG_SSO_STATUS";
export const GET_ORG_SSO_STATUS_SUCCESS = "GET_ORG_SSO_STATUS_SUCCESS";
export const GET_ORG_SSO_STATUS_FAIL = "GET_ORG_SSO_STATUS_FAIL";

